import * as React from "react";
import styled, { css } from "styled-components";
import useLocation from "routing/useLocation";
import { Link } from "components/common";
import AppConfig from "util/AppConfig";
import { Navbar, Nav } from "components/bootstrap";
import GlobalThroughput from "components/throughput/GlobalThroughput";
import Routes from "routing/Routes";
import usePluginEntities from "hooks/usePluginEntities";
import MainNavbar from "components/navigation/MainNavbar";
import { FEATURE_FLAG } from "components/quick-jump/Constants";
import BotaiLogo from "flmall/BotaiLogo";
import UserMenu from "./UserMenu";
import NotificationBadge from "./NotificationBadge";
import DevelopmentHeaderBadge from "./DevelopmentHeaderBadge";
import InactiveNavItem from "./InactiveNavItem";
import StyledNavbar from "./Navigation.styles";
import { QuickJumpModalContainer } from "../quick-jump";
const BrandLink = styled(Link)(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    min-height: 64px;
    color: ${theme.colors.text.primary};

    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.text.primary};
    }
  `
);
const PlatformHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex: none;
    height: 64px;
    padding: 0 16px;
    background: #0b3a6e;
    color: #fff;
    border-bottom: 1px solid rgb(255 255 255 / 12%);

    ${BrandLink} {
      color: #fff;

      &:hover,
      &:active,
      &:focus {
        color: #fff;
      }
    }
  `
);
const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`;
const PlatformTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
`;
const CompanyName = styled.div`
  margin-top: 2px;
  font-size: 12px;
  opacity: 0.85;
`;
const HeaderShell = styled.header`
  flex: none;
  z-index: 1030;
`;
const Navigation = React.memo(({ pathname }) => {
  const pluginItems = usePluginEntities("navigationItems");
  const pluginBadges = usePluginEntities("navigation.badges");
  const activePluginBadges = pluginBadges.filter(({ useCondition }) => useCondition());
  return /* @__PURE__ */ React.createElement(HeaderShell, null, /* @__PURE__ */ React.createElement(PlatformHeader, null, /* @__PURE__ */ React.createElement(BrandLink, { to: Routes.SEARCH, "aria-label": "\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0" }, /* @__PURE__ */ React.createElement(BotaiLogo, null), /* @__PURE__ */ React.createElement(TitleBlock, null, /* @__PURE__ */ React.createElement(PlatformTitle, null, "\u798F\u5229\u5546\u57CE\u65E5\u5FD7\u5E73\u53F0"), /* @__PURE__ */ React.createElement(CompanyName, null, "\u6E56\u5317\u535A\u949B\u667A\u80FD\u79D1\u6280")))), /* @__PURE__ */ React.createElement(StyledNavbar, { fluid: true, collapseOnSelect: true }, /* @__PURE__ */ React.createElement(Navbar.Header, null, /* @__PURE__ */ React.createElement(Navbar.Toggle, null), /* @__PURE__ */ React.createElement(DevelopmentHeaderBadge, { smallScreen: true }), pluginItems.map(({ key, component: Item }) => /* @__PURE__ */ React.createElement(Item, { key, smallScreen: true }))), /* @__PURE__ */ React.createElement(Navbar.Collapse, null, /* @__PURE__ */ React.createElement(MainNavbar, { pathname }), activePluginBadges.map(({ key, component: PluginBadge }) => /* @__PURE__ */ React.createElement(PluginBadge, { key })), /* @__PURE__ */ React.createElement(NotificationBadge, null), /* @__PURE__ */ React.createElement(Nav, { pullRight: true, className: "header-meta-nav" }, AppConfig.isFeatureEnabled(FEATURE_FLAG) ? /* @__PURE__ */ React.createElement(QuickJumpModalContainer, null) : null, AppConfig.isCloud() ? /* @__PURE__ */ React.createElement(GlobalThroughput, { disabled: true }) : /* @__PURE__ */ React.createElement(GlobalThroughput, null), /* @__PURE__ */ React.createElement(InactiveNavItem, { className: "dev-badge-wrap" }, /* @__PURE__ */ React.createElement(DevelopmentHeaderBadge, null), pluginItems.map(({ key, component: Item }) => /* @__PURE__ */ React.createElement(Item, { key }))), /* @__PURE__ */ React.createElement(UserMenu, null)))));
});
const NavigationContainer = () => {
  const { pathname } = useLocation();
  return /* @__PURE__ */ React.createElement(Navigation, { pathname });
};
export default NavigationContainer;
